export function getCurrentTarget(event: React.MouseEvent<HTMLElement>): HTMLElement {
    return event.currentTarget
}

export function stepLabelIsNot(element: HTMLElement, stepLabel: string): boolean {
    return !element.innerHTML.includes(stepLabel)
}

export function getStepLabelFromStepDiv(stepDiv: HTMLElement) {
    return stepDiv.innerText.split(/\s+/)[1];
}